import React from 'react';
import { Box } from '@mui/material';
import { MoreButton, PermissionsGate, FavoriteDashboard } from '@components';
import { NoAccess } from 'components/common/ui';

import styles from './pageListLayout.style';

const PageListLayout = ({
  renderHeaderOptions,
  children,
  entity,
  disablePermissionGate,
  title,
  actions,
}) => {
  return (
    <PermissionsGate
      entity={entity}
      RenderError={NoAccess}
      disabled={disablePermissionGate}
    >
      <Box sx={styles.wrapper}>
        <Box data-testid="page-list-header" sx={styles.header}>
          <Box sx={styles.title}>
            {title && (
              <>
                <FavoriteDashboard />
                <Box
                  component="h6"
                  m={0}
                  fontWeight={700}
                  fontSize="14px"
                  lineHeight="normal"
                >
                  {title}
                </Box>
              </>
            )}
          </Box>
          <Box sx={styles.headerOptions}>
            <MoreButton moreOptions={actions} />
            {renderHeaderOptions && renderHeaderOptions()}
          </Box>
        </Box>

        <Box>{children}</Box>
      </Box>
    </PermissionsGate>
  );
};

export default PageListLayout;
